import { Fragment, useEffect, useState } from "react";
import Lottie from "lottie-react";
import { Link } from "react-router-dom";
import { fetchPublicFilingReviewList } from "../../../../../api/reviews/FilingReview";
import BaseCarousel from "../../../../ui/carousels/common/BaseCarousel";
import FiReviewCard from "../../../../ui/cards/finances/FiReviewCard";
import LoadingPlaceholder from "../../../../ui/loading/LoadingPlaceholder";

function ProductTaxFiling({ content = {} }) {
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState([]);

  const images = content.audiences || [];
  const infiniteImages = [...images, ...images];

  async function getReviews() {
    setLoading(true);
    const apiUrl = "tax/filings/public-reviews";
    try {
      const response = await fetchPublicFilingReviewList(apiUrl);
      if (response.ok) {
        const responseData = await response.json();
        setReviews((responseData || []).slice(0, 4));
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getReviews();
  }, []);

  return (
    <Fragment>
      <div className="product-container">
        <div className="product-left-header">
          <div className="product-icon-header">
            <Lottie
              path={`${process.env.PUBLIC_URL}/lottie/tax.json`}
              loop
              autoplay
            />
          </div>
          <div className="product-content-header">
            <h2>{content.heading}</h2>
            <p>{content.description}</p>
          </div>
        </div>
        <div className="product-right">
          <div className="product-right-section">
            <h3>{content.expert_heading}</h3>
            <div>
              {content.expert_content?.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
          <div className="expert-filing-audiences product-right-section">
            <h3>{content.audiences_heading}</h3>
            <div className="audiences-carousel-viewport">
              <div className="audiences-carousel circular-track">
                {infiniteImages.map((item, index) => (
                  <div className="audience-item" key={index}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/${item.src}`}
                      alt={item.title}
                    />
                    <div className="audience-item-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="product-right-section ">
            <h3>{content.benefits_heading}</h3>
            <div className="list-container">
              {content.benefits?.map((benefit, index) => (
                <div className="list-item" key={index}>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icons/verified_gray.svg`}
                    alt=""
                    className="list-item-icon"
                  />
                  <span className="list-item-span">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="product-left">
          {(loading || reviews.length > 0) && (
            <BaseCarousel
              items={reviews}
              isLoading={loading}
              showBorder={false}
              showArrows={true}
              showDots={true}
              containerClassName="tf-review-carousel"
              GhostComponent={<LoadingPlaceholder rows={1} type="card-large" />}
              renderItem={(rev, index) => (
                <FiReviewCard
                  key={rev.id || index}
                  name={rev.username}
                  review={rev.desc}
                  rate={rev.rate}
                  avatar={rev.avatar}
                />
              )}
            />
          )}

          <div className="tf-review-cta-container">
            <Link to="/sign-up" className="cta-button primary">
              {content.cta}
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ProductTaxFiling;
